import React from 'react'

import pill from "./../../../UI/general/pill.svg"

interface Props {
  colorsData: any
  attributesData: any,
  handleSelectTownPlanningFilter: any
}

interface State {
  isCollapsed: boolean,
  currentHovered: number,
  currentSelected: number
}

class TownPlanningSidebar extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      isCollapsed: false,
      currentHovered: -1,
      currentSelected: -1
    }
  }

  render(): React.ReactNode {
      return(
        <React.Fragment>
          <div className={this.state.isCollapsed ? 'sidebar-townplanning-collapsed-mobile':'sidebar-townplanning-mobile'}>
            <div className='hide-amenities-mobile-container'>
              <img src={pill} alt=""></img>
            </div>
            <div className='townplanning-icon-text-container-mobile'>
              <div className='townplanning-image-container-mobile'>
                <img src={'./UI/menu/urbanismo.svg'} alt=''></img>
              </div>
              <div className='townplanning-text-mobile'>URBANISMO</div>
            </div>

            <div className='townplanning-btns-container-mobile'>
              {
                this.props.attributesData.map((attribute: any, index: number) => 
                  <div 
                  className='townplanning-selection-btn'
                  key={attribute.name + attribute.id + index}
                  onMouseEnter={() => {this.setState({currentHovered: index})}}
                  onMouseLeave={() => {this.setState({currentHovered: -1})}}
                  onClick={() => {
                    this.setState({
                      currentSelected: index
                    }, () => {
                      this.props.handleSelectTownPlanningFilter(attribute.name)
                    })
                  }}
                  style={{
                    backgroundColor: this.state.currentSelected === index ? this.props.colorsData.main_buttons: this.state.currentHovered === index ? this.props.colorsData.secondary_buttons:"",
                    color: this.state.currentSelected === index ? this.props.colorsData.secondary_text: this.props.colorsData.main_text
                  }}
                  >
                    <div>{attribute.name}</div>
                  </div>
                )
              }
            </div>
          </div>
        </React.Fragment>
      )
  }
}

export default TownPlanningSidebar